import * as Sentry from '@sentry/react';

interface LogContext {
  [key: string]: unknown;
}

function formatMessage(message: string, context?: LogContext): string {
  if (!context) return message;
  return `${message} ${JSON.stringify(context)}`;
}

export const logger = {
  error(message: string, error?: unknown, context?: LogContext) {
    console.error(formatMessage(message, context), error);
    if (error instanceof Error) {
      Sentry.captureException(error, { extra: context });
    } else if (error) {
      Sentry.captureException(new Error(message), { extra: { ...context, originalError: error } });
    } else {
      Sentry.captureException(new Error(message), { extra: context });
    }
  },

  warn(message: string, context?: LogContext) {
    console.warn(formatMessage(message, context));
    Sentry.addBreadcrumb({
      level: 'warning',
      message,
      data: context,
    });
  },

  info(message: string, context?: LogContext) {
    if (import.meta.env.DEV) {
      console.info(formatMessage(message, context));
    }
    Sentry.addBreadcrumb({
      level: 'info',
      message,
      data: context,
    });
  },

  debug(message: string, context?: LogContext) {
    if (import.meta.env.DEV) {
      console.debug(formatMessage(message, context));
    }
  },
};
